export default __webpack_public_path__ + "static/media/enterprise.849ae3f8.svg";